import React, { useEffect, useState } from 'react';
import CheckBoxRoundGreen from '../../Icons/CheckBoxRoundGreen';
import CheckBoxRound from '../../Icons/CheckBoxRound';

const DefaultCheckList = [
  {
    isPassed: false,
    title: 'At least 8 characters',
  },
  {
    isPassed: false,
    title: 'Contains a number',
  },
  {
    isPassed: false,
    title: 'Contains a special character',
  },
];

const PasswordCheckList = ({ style, password, updatePasswordValidity }) => {
  const [passwordChecks, setPasswordChecks] = useState(DefaultCheckList);

  useEffect(() => {
    if (password) {
      let speicalCharsformat = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      let checkList = [...DefaultCheckList];
      checkList[0].isPassed = password.length >= 8 ? true : false;
      checkList[1].isPassed = /\d/.test(password) ? true : false;
      checkList[2].isPassed = speicalCharsformat.test(password) ? true : false;
      const isPasswordValid = checkList.filter((item) => item.isPassed).length === 3 ? true : false;
      setPasswordChecks(checkList);
      updatePasswordValidity(isPasswordValid);
    } else {
      setPasswordChecks(DefaultCheckList);
      updatePasswordValidity(false);
    }
  }, [password, updatePasswordValidity]);

  return (
    <div style={style}>
      {passwordChecks.map(({ isPassed, title }) => (
        <div className="d-flex align-items-center mb-3">
          {isPassed ? <CheckBoxRoundGreen /> : <CheckBoxRound />}
          <p className="field-container__account-helper-text ms-3">{title}</p>
        </div>
      ))}
    </div>
  );
};

export default PasswordCheckList;
